import { render, staticRenderFns } from "./FactorIndicator.vue?vue&type=template&id=4a8f1840"
import script from "./FactorIndicator.vue?vue&type=script&lang=js"
export * from "./FactorIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports